import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import * as Recharts from 'recharts';
import { useAppContext } from '../../context/AppContext.js';
import Title from '../../components/Title.js';
import IconBudgetOperation from '../../components/icons/IconBudgetOperation.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';
import { format } from '../../utils/format.js';

const UsersMonitorRight = ReactRouterDOM.withRouter(function ({ user }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [data, setData] = React.useState([]);
  const definedColors = {
    inRevision: 'red',
    confirmed: 'gold',
    sent: 'green',
  };

  React.useEffect(() => {
    loadData();
  }, [user]);

  const loadData = async function () {
    let records = null;
    try {
      const args = {};
      if (user.userId !== null && user.userId !== undefined) {
        args.userUserId = user.userId;
      }
      records = await ApiService.getAggregateBudgetOperations(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    const data = records.map((record, index) => ({
      name: record.status,
      translate: true,
      value0: record.countOfRecords,
      color: definedColors[record.status]
    }));
    data.sort((a, b) => b.value0 - a.value0);
    setData(data);
  }
  
  const translatedData = data.map((item) => ({
    name: item.translate ? words[item.name] : item.name,
    value0: item.value0,
    color: item.color
  }));
  
  const renderLabel = function ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, name, color, value }, type) {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * Math.PI / 180);
    const y = cy + radius * Math.sin(-midAngle * Math.PI / 180);
    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${format(value, type)} (${(percent * 100).toFixed(0)}%)`}
      </text>
    );
  }
  
  return (
    <div>
      <div>
        <div className="pb-1 d-flex align-items-center border-bottom">
          <Title level={1} icon={IconBudgetOperation} color="sky-blue" label={words.operations} />
          <div className="flex-grow-1" />
        </div>
        <Recharts.ResponsiveContainer width="100%" aspect={1}>
          <Recharts.PieChart>
            <Recharts.Pie
              data={translatedData}
              nameKey="name"
              dataKey="value0"
              isAnimationActive={false}
              labelLine={false}
              label={(e) => renderLabel(e, 'integer')}
            >
              {translatedData.map((entry, index) => (
                <Recharts.Cell key={'cell-' + index} className={'fill-' + entry.color} />
              ))}
            </Recharts.Pie>
            <Recharts.Tooltip
              formatter={(value, name) => [format(value, 'integer'), name]}
            />
          </Recharts.PieChart>
        </Recharts.ResponsiveContainer>
        <ul className="d-flex flex-wrap">
          {translatedData.map((entry, index) => (
            <li style={{ paddingRight: 24 }} className={'text-nowrap text-' + entry.color} key={'item-' + index}>{entry.name}</li>
          ))}
        </ul>
      </div>
    </div>
  );
})

export default UsersMonitorRight;
